var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolygon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2901,
    height: 2948,
    viewBox: "0 0 2901 2948",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_28_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1287.66 42.4515C1339.14 28.8647 1364.88 22.0712 1390.89 16.8749C1429.7 9.12157 1469 4.02285 1508.51 1.61424C1534.99 0 1561.6 0 1614.84 0V0C1997.73 0 2189.18 0 2341.38 59.147C2569.13 147.653 2749.24 327.755 2837.74 555.507C2896.89 707.709 2896.89 899.155 2896.89 1282.05V1491.61C2896.89 2031.21 2896.89 2301 2781.48 2502.27C2704.56 2636.42 2593.31 2747.67 2459.16 2824.59C2257.89 2940 1988.1 2940 1448.5 2940V2940L1268.77 2916.71C1009.03 2883.05 879.153 2866.22 764.571 2815.83C672.149 2775.18 587.498 2718.77 514.399 2649.13C423.775 2562.78 358.238 2449.4 227.164 2222.64V2222.64C122.567 2041.68 70.269 1951.2 41.042 1854C17.4326 1775.48 5.02835 1694.02 4.19673 1612.03C3.16725 1510.54 26.165 1408.59 72.1603 1204.71L77.3236 1181.82C155.264 836.331 194.234 663.586 287.834 526.392C343.138 445.331 411.743 374.198 490.751 315.998C624.469 217.496 795.691 172.304 1138.14 81.9182L1287.66 42.4515Z",
    fill: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2896.39 1282.05V1491.61C2896.39 1761.42 2896.39 1963.74 2881.97 2123.77C2867.54 2283.79 2838.7 2401.48 2781.05 2502.02C2704.17 2636.09 2592.98 2747.28 2458.91 2824.16C2358.37 2881.81 2240.68 2910.65 2080.66 2925.08C1920.64 2939.5 1718.32 2939.5 1448.53 2939.5L1268.84 2916.21C1009.06 2882.55 879.273 2865.73 764.773 2815.37C672.403 2774.75 587.801 2718.37 514.744 2648.76C424.184 2562.48 358.686 2449.18 227.597 2222.39C122.989 2041.41 70.7271 1950.99 41.5209 1853.86C17.9249 1775.38 5.52784 1693.97 4.69671 1612.03C3.66795 1510.61 26.6476 1408.73 72.6481 1204.82L77.8114 1181.93C155.76 836.401 194.713 663.77 288.247 526.674C343.52 445.659 412.085 374.567 491.048 316.401C624.671 217.969 795.779 172.798 1138.26 82.4017L1287.79 42.9349C1339.27 29.3466 1364.99 22.5579 1390.99 17.3653C1429.78 9.61633 1469.05 4.52054 1508.54 2.11331C1535 0.500211 1561.6 0.5 1614.84 0.5C1806.3 0.5 1949.86 0.500241 2064.59 7.89234C2179.31 15.2842 2265.17 30.0659 2341.2 59.6131C2568.82 148.069 2748.82 328.067 2837.28 555.688C2866.82 631.722 2881.61 717.576 2889 832.3C2896.39 947.028 2896.39 1090.59 2896.39 1282.05Z",
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_28_3",
    x: 0.163574,
    y: 0,
    width: 2900.73,
    height: 2948,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_28_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_28_3",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon1);
export default __webpack_public_path__ + "static/media/Polygon 1.6a4413d9321e0a1206c19b77e9f0c77a.svg";
export { ForwardRef as ReactComponent };